import { styled } from "styled-components";

export const TournamentListWrapper = styled.div`
  width: calc(100% - 60px);
  height: calc(100% - 68px);

  padding: 30px 30px 38px;
  border-radius: 20px;
  background: #f0f3f8;

  display: flex;
  flex-direction: column;

  justify-content: space-between;
`;

export const TournamentListSearchWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  gap: 8px;
`;

export const TournamentListSearchInputBox = styled.div`
  width: 308px;
  display: flex;
  flex-direction: row;
  border-radius: 15px;
  background: #fff;
  padding: 0 15px;
  align-items: center;
  gap: 7px;
  border: 1px solid #b7b7b7;
  height: 40px;

  > input {
    flex: 1;
    border: none;
    outline: none;

    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const TournamentListBoxWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 35px;
  border-top: 2px solid #d9d9d9;
`;

export const TournamentListHeaderWrapper = styled.div`
  margin-top: 19px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const TournamentListHeaderItemWrapper = styled.div<{ width: string }>`
  width: ${({ width }) => width};
  display: flex;
  justify-content: center;
  align-items: center;

  color: #121212;
  font-family: Pretendard;
  font-size: 12.605px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
`;

export const TournamentListDataWrapper = styled.div`
  margin-top: 19px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TournamentListDataItemWrapper = styled.div`
  width: 100%;

  padding: 16px 9px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  border-radius: 9.635px;
  background: #fff;
  cursor: pointer;
`;

export const TournamentListDataItem = styled.div<{ width: string }>`
  width: ${({ width }) => width};
  display: flex;
  justify-content: center;
  align-items: center;
  color: #121212;
  font-family: Pretendard;
  font-size: 12.605px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
